/*
  Media slider
  - Swiper with fractional slidesPerView (separate desktop/mobile values).
  - Video slides: click to play, click again to pause; playing one pauses the others;
    the centre play button reappears on pause/end. One player at a time.

  COREEX Focal port: logic carried over from dev-coreex-theme unchanged except the
  desktop breakpoint (990 -> 1000, matching Focal's lap-and-up). Focal bundles
  Flickity, not Swiper, so ensureSwiper's window.Swiper check always misses and the
  CDN loader runs — which is the intended behaviour, and it cannot clash with
  Flickity since the two libraries share no globals or class names.
*/
(function () {
  'use strict';

  var CDN_JS = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js';
  var CDN_CSS = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.css';

  function ensureSwiper(cb) {
    if (window.Swiper) return cb();

    if (!document.getElementById('swiper-cdn-css')) {
      var link = document.createElement('link');
      link.id = 'swiper-cdn-css';
      link.rel = 'stylesheet';
      link.href = CDN_CSS;
      document.head.appendChild(link);
    }

    var existing = document.getElementById('swiper-cdn-js');
    if (existing) {
      existing.addEventListener('load', cb);
      return;
    }

    var s = document.createElement('script');
    s.id = 'swiper-cdn-js';
    s.src = CDN_JS;
    s.addEventListener('load', cb);
    document.head.appendChild(s);
  }

  function setupVideos(section) {
    var slides = section.querySelectorAll('.media-slider__slide[data-video]');
    var videos = [];

    for (var i = 0; i < slides.length; i++) {
      (function (slide) {
        var video = slide.querySelector('video');
        if (!video) return;
        videos.push(video);
        var media = slide.querySelector('.media-slider__media');

        media.addEventListener('click', function () {
          if (video.paused) {
            for (var j = 0; j < videos.length; j++) {
              if (videos[j] !== video) videos[j].pause();
            }
            var p = video.play();
            if (p && p.catch) p.catch(function () {});
          } else {
            video.pause();
          }
        });

        video.addEventListener('play', function () {
          slide.classList.add('is-playing');
        });
        video.addEventListener('pause', function () {
          slide.classList.remove('is-playing');
        });
        video.addEventListener('ended', function () {
          slide.classList.remove('is-playing');
          video.currentTime = 0;
        });
      })(slides[i]);
    }

    return videos;
  }

  function initSection(section) {
    if (!section || section.__msInit) return;
    section.__msInit = true;

    var slider = section.querySelector('.media-slider__slider');
    if (!slider) return;

    var dSPV = parseFloat(section.getAttribute('data-spv-desktop')) || 4;
    var mSPV = parseFloat(section.getAttribute('data-spv-mobile')) || 1.2;
    var gap = parseInt(section.getAttribute('data-gap'), 10) || 16;

    var videos = setupVideos(section);

    function pauseAll() {
      for (var i = 0; i < videos.length; i++) videos[i].pause();
    }

    ensureSwiper(function () {
      section.__msSwiper = new Swiper(slider, {
        slidesPerView: mSPV,
        spaceBetween: gap,
        grabCursor: true,
        watchOverflow: true,
        breakpoints: {
          1000: { slidesPerView: dSPV, spaceBetween: gap },
        },
        a11y: { enabled: true },
        on: {
          // pause any playing video once the user starts dragging to a new position
          slideChangeTransitionStart: pauseAll,
        },
      });
    });
  }

  function initAll(scope) {
    var nodes = (scope || document).querySelectorAll('.media-slider');
    for (var i = 0; i < nodes.length; i++) initSection(nodes[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (e) {
    var r = e.target.querySelector('.media-slider');
    if (r) {
      r.__msInit = false;
      initSection(r);
    }
  });

  document.addEventListener('shopify:section:unload', function (e) {
    var r = e.target.querySelector('.media-slider');
    if (r && r.__msSwiper) {
      r.__msSwiper.destroy(true, true);
      r.__msSwiper = null;
      r.__msInit = false;
    }
  });
})();
